import { Component, NgModule, ViewContainerRef, TemplateRef } from '@angular/core';
import { ProductService } from '../../services/product/product.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { BrowserModule } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Attributes } from '../../models/products/product.model';
import { ProductVariants } from '../../models/products/product.model';
import { Variants } from '../../models/products/product.model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
    selector: 'app-attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.css']
})
/** Attributes component*/
export class AttributesComponent {

  public attributeList: Attributes[] = [];
  public variantsList: Variants[] = [];
  public attribute = new Attributes();
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
    /** Attributes ctor */
  constructor(private modalService: BsModalService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly productService: ProductService, private readonly router: Router,
    private readonly utilitiesService: UtilitiesService, private readonly rolePermissionService: RolePermissionService)
  {
    this.rolePermissionService.GetRolePermissions("attribute").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;

          this.toastr.setRootViewContainerRef(vcr);
          this.GetAttributes();
          this.GetRowsPerPageList();
          this.GetVariantsList();
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }
  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  GetAttributes() {
    this.productService.GetAttributeList().subscribe(
      data => {
        this.attributeList = data;
      });
  }
    // Populate the row per page list
    GetRowsPerPageList() {
      this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
      this.rowsOnPage = this.arrRowsPerPage[0];
    }
  GetVariantsList() {

    this.productService.GetAllVariantsList().subscribe(
      data => {
        this.variantsList = data;
      });
  }
  deleteAttribute(id) {

    var ans = confirm("Are you sure to delete this attribute?");
    if (ans) {
      this.productService.deleteAttribute(id);
      setTimeout(() => {
        this.GetAttributes();
      }, 2000);
    }
  }
  AddAttribute() {
    
    this.productService.AddAttribute(this.attribute).subscribe(
      data => {
        if (data > 0) {
          this.toastr.success('Attribute added Successfully.', 'Success');
          this.attribute = new Attributes();
          this.GetAttributes();
        }
        else {
          this.toastr.error('Attribute already exist.', 'Error');
          this.attribute = new Attributes();
        }
      });
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/product-components/attributes/attributes.component.ts